import React from 'react';
import { Badge } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStamp } from '@fortawesome/pro-regular-svg-icons';

export default function AssessorMatchBadge() {
  return (
    <Badge bg="" className="secondary-outline badge-sm py-0-5">
      <FontAwesomeIcon icon={faStamp} size="xs" />
      <span className="d-none d-md-inline fs-x-small">Assessor Match</span>
      <span className="d-md-none fs-x-small">LLC</span>
    </Badge>
  );
}
